import request from './index.js';

export const getJwtHeaderInfo = () => {
  const accessToken = localStorage.getItem('accessToken');
  return {
    'X-ACCESS-TOKEN': accessToken,
  };
};

export const getPnHeaderInfo = () => {
  const localStorageKey = 'pn_auth_user_info_' + process.env.VUE_APP_PN_APPID;
  const pnUserInfo = JSON.parse(localStorage.getItem(localStorageKey));
  let uuid = '';
  let token = '';
  if (
    pnUserInfo !== null &&
    typeof pnUserInfo.uuid !== 'undefined' &&
    typeof pnUserInfo.token !== 'undefined'
  ) {
    uuid = pnUserInfo.uuid;
    token = pnUserInfo.token;
  }

  return {
    'X-USER-UUID': uuid,
    'X-USER-TOKEN': token,
  };
};

export const createRocketOrder = (data) => {
  return request({
    url: '/rocket/order',
    method: 'post',
    headers: getJwtHeaderInfo(),
    data: data,
  });
};

export const particleNetworkLogin = async () => {
  return request({
    url: '/rocket/auth/login',
    method: 'post',
    headers: getPnHeaderInfo(),
  });
};

export const particleNetworkLogout = async () => {
  return request({
    url: '/rocket/auth/logout',
    method: 'post',
    headers: getPnHeaderInfo(),
  });
};

export const isParticleNetworkExpired = () => {
  return request({
    url: '/rocket/auth/expired',
    method: 'get',
    headers: getPnHeaderInfo(),
  });
};

export const getParticleNetworkUserInfo = () => {
  return request({
    url: '/rocket/user',
    method: 'get',
    headers: getJwtHeaderInfo(),
  });
};

export const createReferralCode = (data) => {
  return request({
    url: '/rocket/user/referral',
    method: 'post',
    headers: getJwtHeaderInfo(),
    data: data,
  });
};

export const getReferralList = () => {
  return request({
    url: '/rocket/user/referral',
    method: 'get',
    headers: getJwtHeaderInfo(),
  });
};

export const getCollaterlizedLendingNftDetail = (query) => {
  return request({
    url: '/lendings/collateralized/one',
    method: 'get',
    params: query,
  });
};

export const getCollaterlFreeLendingNftDetail = (query) => {
  return request({
    url: '/lendings/collateralFree/one',
    method: 'get',
    params: query,
  });
};

export const getAllLendingNFTList = (query) => {
  return request({
    url: '/lendings/all',
    method: 'get',
    params: query,
  });
};

export const getCollateralizedLendingNFTList = (query) => {
  return request({
    url: '/lendings/collateralized',
    method: 'get',
    params: query,
  });
};

export const getCollateralFreeLendingNFTList = (query) => {
  return request({
    url: '/lendings/collateralFree',
    method: 'get',
    params: query,
  });
};

export const getOneNFT = (query) => {
  return request({
    url: '/nft/one',
    method: 'get',
    params: query,
  });
};

export const getMyNftList = (query) => {
  return request({
    url: '/user/mynft',
    method: 'get',
    params: query,
  });
};

export const getMyLendingNFTList = (query) => {
  return request({
    url: '/lendings/user',
    method: 'get',
    params: query,
  });
};

export const getMyRentingNFTList = (query) => {
  return request({
    url: '/rentings',
    method: 'get',
    params: query,
  });
};

export const getAllcollection = (query) => {
  return request({
    url: '/nft',
    method: 'get',
    params: query,
  });
};

export const getOnchainNftGallery = (query) => {
  return request({
    url: '/nft/gallery',
    method: 'get',
    params: query,
  });
};

export const getOnchainNftGalleryItem = (id) => {
  return request({
    url: `/nft/gallery/${encodeURIComponent(id)}`,
    method: 'get',
  });
};

export const createNFTCategory = (data) => {
  return request({
    url: '/nft',
    method: 'post',
    data: data,
  });
};

export const getRocketHistory = () => {
  return request({
    url: '/rocket/program/history',
    method: 'get',
    headers: getJwtHeaderInfo(),
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const getPrograms = () => {
  return request({
    url: '/rocket/program',
    method: 'get',
    headers: getJwtHeaderInfo(),
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const postGenerateImage = (formData) => {
  return request({
    url: '/rocket/images/generate',
    method: 'post',
    mimeType: 'multipart/form-data',
    headers: getJwtHeaderInfo(),
    data: formData,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const pollingGenerateImage = (query) => {
  return request({
    url: '/rocket/polling/generateImages/' + query,
    method: 'get',
    headers: getJwtHeaderInfo(),
  });
};

export const pollingUploadImage = (query) => {
  return request({
    url: '/rocket/polling/uploadImages/' + query,
    method: 'get',
    headers: getJwtHeaderInfo(),
  });
};

export const postUploadImage = (formData) => {
  return request({
    url: '/rocket/images/upload',
    method: 'post',
    mimeType: 'multipart/form-data',
    headers: getJwtHeaderInfo(),
    data: formData,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const postMint = (formData) => {
  return request({
    url: '/rocket/nft/mint',
    method: 'post',
    headers: getJwtHeaderInfo(),
    data: formData,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const pollingMint = (query) => {
  return request({
    url: '/rocket/polling/nftMint/' + query,
    method: 'get',
    headers: getJwtHeaderInfo(),
  });
};

export const postTransferOwnership = (formData) => {
  return request({
    url: '/rocket/nft/transferOwnership',
    method: 'post',
    headers: getJwtHeaderInfo(),
    data: formData,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
};

export const pollingTransferOwnership = (query) => {
  return request({
    url: '/rocket/polling/transferOwnership/' + query,
    method: 'get',
    headers: getJwtHeaderInfo(),
  });
};

export const getNFTtokenMessage = (query) => {
  return request({
    url: '/nft/redeem/message/token',
    method: 'get',
    params: query,
  });
};
export const registerNFTToken = (data) => {
  return request({
    url: '/nft/redeem/register/token',
    method: 'post',
    data: data,
  });
};

export const getNFTclaimMessage = (query) => {
  return request({
    url: '/nft/redeem/message/claim',
    method: 'get',
    params: query,
  });
};

export const redeemNFTToken = (data) => {
  return request({
    url: `/nft/redeem/claim/${data.chainId}/${data.nftAddress}/${data.tokenId}`,
    method: 'post',
    data: {
      ownerAddress: data.ownerAddress,
      ecdsaSignature: data.ecdsaSignature,
    },
  });
};

export const createLoginRecord = (address, chainId) => {
  return request({
    url: `/user/metamask`,
    method: 'post',
    data: {
      address: address,
      chainId: chainId,
    },
  });
};
